(function () {
  if (customElements.get('email-capture')) return;

  const DAY = 24 * 60 * 60 * 1000;

  class EmailCapture extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dialog = this.querySelector('[data-csr-capture-dialog]');
      this.closeButton = this.querySelector('[data-csr-capture-close]');
      this.emailInput = this.querySelector('[data-csr-capture-email]');
      this.form = this.querySelector('form');
      this.success = Boolean(this.querySelector('[data-csr-capture-success]'));
      this.storageKey = this.dataset.storageKey || 'csr-relief-list-v1';
      this.dismissDays = Number(this.dataset.dismissDays || 21);
      this.scrollPercent = Number(this.dataset.scrollPercent || 42);
      this.delay = Number(this.dataset.delay || 12000);
      this.timer = null;
      this.previousFocus = null;

      if (!this.dialog) return;
      this.dataset.initialized = 'true';

      this.closeButton?.addEventListener('click', () => this.dismiss());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.dismiss();
      });
      this.dialog.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.dismiss();
      });
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('csr-capture-open');
        this.previousFocus?.focus?.();
      });
      this.form?.addEventListener('submit', () => this.markJoined());

      if (this.success) {
        this.markJoined();
        window.setTimeout(() => this.open(), 200);
        return;
      }

      if (window.Shopify?.designMode || this.isSuppressed()) return;

      this.onScroll = () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable <= 0) return;
        const percent = (window.scrollY / scrollable) * 100;
        if (percent >= this.scrollPercent) this.open();
      };

      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.timer = window.setTimeout(() => this.open(), this.delay);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      if (this.timer) window.clearTimeout(this.timer);
    }

    open() {
      if (this.dialog.open || this.isSuppressed() && !this.success) return;

      if (this.timer) window.clearTimeout(this.timer);
      window.removeEventListener('scroll', this.onScroll);
      this.previousFocus = document.activeElement;

      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }

      document.documentElement.classList.add('csr-capture-open');
      window.setTimeout(() => (this.emailInput || this.closeButton)?.focus(), 50);
    }

    dismiss() {
      this.setStorage({
        state: 'dismissed',
        expires: Date.now() + this.dismissDays * DAY
      });
      this.dialog.close();
    }

    markJoined() {
      this.setStorage({
        state: 'joined',
        expires: Date.now() + 365 * DAY
      });
    }

    isSuppressed() {
      try {
        const stored = JSON.parse(localStorage.getItem(this.storageKey));
        return stored && Number(stored.expires) > Date.now();
      } catch (error) {
        return false;
      }
    }

    setStorage(value) {
      try {
        localStorage.setItem(this.storageKey, JSON.stringify(value));
      } catch (error) {
        // Storage can be unavailable in private browsing; the form still works.
      }
    }
  }

  customElements.define('email-capture', EmailCapture);
})();
